export default __webpack_public_path__ + "static/media/SurveyConfirmation.44185ca5.svg";